import { MakeCall } from './createMakeCall';
import { ConversationsCounters } from './types/ConversationsCounters';

interface Query {
  listingId?: number;
}

export default (makeCall: MakeCall) => (userId: number, query?: Query) =>
  makeCall<ConversationsCounters>(
    'GET',
    `/api/v2/conversations/counters/user/${userId}`,
    { query },
  );
